import React from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import { editSets } from "../../actions/settings"
import DeleteConfirmation from '../ui/DeleteConfirmation'
import LinksReplacer from '../ui/LinksReplacer'
import SettingsItemForm from './SettingsItemForm'
import { sortOpts } from '../../utils/utils'

class SetsPlaceItem extends SettingsItemForm {

  modelName = 'place'

  render() {
    const { data, ptypes } = this.props;
    const { data: nData, errors } = this.state;

    const delConf = this.state.delConf ?
      <DeleteConfirmation
        onDelete={this.deleteItem}
        onCancel={this.toggleDelConf}
      />
      :
      '';

    const ptypesOpt = [];
    for (let key in ptypes){
      if(ptypes.hasOwnProperty(key) && (ptypes[key].ptype_active === 1
        || ptypes[key].ptype_id === data.place_ptype_id)) {
        ptypesOpt.push({value:ptypes[key].ptype_id,label:ptypes[key].ptype_desc});
      }
    }
    ptypesOpt.sort(sortOpts);

    const place_ptype_desc = ptypes[data.place_ptype_id] ?
      ptypes[data.place_ptype_id].ptype_desc : '(Пусто)'

    if(this.state.editing){
      return(
        <tr>
          <td>
          {delConf}
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.place_desc}
                name="place_desc"
                onChange={this.updateInput}
                placeholder="Название"
                autoFocus
              />
            </div>
            <div className="form-inline">
              <button  type="button" className="btn btn-success"
                onClick={this.saveItem} title="Сохранить">
                <span className="glyphicon glyphicon-save"></span>
              </button>{" "}
              <button type="button" className="btn btn-default"
                onClick={this.cancelEditing} title="Отменить">
                <span className="glyphicon glyphicon-remove"></span>
              </button>{" "}
              <button type="button" className="btn btn-danger"
                onClick={this.toggleDelConf} title="Удалить">
                <span className="glyphicon glyphicon-trash"></span>
              </button>
            </div>
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          </td>
          <td>
            <div className="form-group">
              <Select
                clearable={false}
                options={ptypesOpt}
                value={nData.place_ptype_id}
                onChange={e => this.updateSelect(e,'place_ptype_id')}
                placeholder="Тип"
              />
            </div>
          </td>
          <td>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.place_address}
                name="place_address"
                onChange={this.updateInput}
                placeholder="Адрес"
              />
            </div>
          </td>
          <td>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.place_contact}
                name="place_contact"
                onChange={this.updateInput}
                placeholder="Контакты"
              />
            </div>
          </td>
          <td>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.place_price}
                name="place_price"
                onChange={this.updateInput}
                placeholder="Цена"
              />
            </div>
          </td>
          <td>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.place_price_per}
                name="place_price_per"
                onChange={this.updateInput}
                placeholder="Ср.чек"
              />
            </div>
          </td>
          <td>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.place_capacity_ban}
                name="place_capacity_ban"
                onChange={this.updateInput}
                placeholder="Мест, банкет"
              />
            </div>
          </td>
          <td>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.place_capacity_fur}
                name="place_capacity_fur"
                onChange={this.updateInput}
                placeholder="Мест, фуршет"
              />
            </div>
          </td>
          <td>
            <div className="form-group">
              <textarea type="text"
                rows="4"
                className="form-control"
                value={nData.place_note}
                name="place_note"
                onChange={this.updateInput}
                placeholder="Заметка"
              />
            </div>
          </td>
        </tr>
      );
    }
    else{
      return (
        <tr onClick={this.startEditing}>
          <td>{data.place_desc}</td>
          <td>{place_ptype_desc}</td>
          <td>{data.place_address}</td>
          <td>{data.place_contact}</td>
          <td>{data.place_price}</td>
          <td>{data.place_price_per}</td>
          <td>{data.place_capacity_ban}</td>
          <td>{data.place_capacity_fur}</td>
          <td>
            <LinksReplacer
              text={data.place_note}
            />
          </td>
        </tr>
      );
    }

  }
}

export default connect(null, { editSets })(SetsPlaceItem);



// WEBPACK FOOTER //
// ./src/components/settings/SetsPlaceItem.js